export default function VSCode(){
	return (
		<div className="mock-app mock-vscode">
			<aside className="mock-vscode-sidebar">
				<span>EXPLORER</span>
				<span>SEARCH</span>
				<span>SOURCE CONTROL</span>
				<span>RUN</span>
			</aside>
			<main className="mock-vscode-editor">
				<div className="mock-vscode-tabs">COMING IN NEXT UPDATE</div>
			</main>
		</div>
	);
}
